import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import "../static/css/publicationDetail.css";

function PublicationDetailPage() {
    const location = useLocation();
    const navigate = useNavigate();
    const { publication, allPublications = [] } = location.state || {};

    if (!publication) {
        return (
            <>
                <Nav />
                <div className="publication-detail">
                    <div style={{ textAlign: "center", padding: "50px", minHeight: "400px" }}>
                        <h2>Publication not found</h2>
                        <p>Please select a publication from the publications page.</p>
                        <button
                            onClick={() => navigate("/publications")}
                            style={{
                                padding: "10px 20px",
                                backgroundColor: "#007bff",
                                color: "white",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                            }}
                        >
                            Back to Publications
                        </button>
                    </div>
                </div>
                <Footer />
            </>
        );
    }

    return (
        <>
            <Nav />
            <div className="publication-detail">
                {/* Header Section */}
                <div className="detail-header">
                    {publication.imgSrc && (
                        <div className="header-image">
                            <img src={publication.imgSrc} alt={publication.title} />
                        </div>
                    )}
                    <div className="header-content">
                        <h1>{publication.title}</h1>
                        {publication.date && (
                            <p className="pub-date">
                                <strong>Published:</strong>{" "}
                                {new Date(publication.date).toLocaleDateString("en-US", {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                })}
                            </p>
                        )}
                        <p>{publication.description}</p>
                    </div>
                </div>

                {/* Content Section with Sidebar */}
                <div className="pop-sidebar-con" style={{ maxWidth: "1200px", margin: "0 auto", padding: "30px 20px" }}>
                    {/* Main Side: Content + Table */}
                    <div style={{ flex: 1, minWidth: 0 }}>
                        {/* Article Body */}
                        <div
                            style={{
                                backgroundColor: "#fff",
                                padding: "40px",
                                borderRadius: "12px",
                                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
                                marginBottom: "15px"
                            }}
                        >
                            {publication.content ? (
                                <div
                                    dangerouslySetInnerHTML={{ __html: publication.content }}
                                    style={{ 
                                        lineHeight: "1.8", 
                                        color: "#333", 
                                        fontSize: "1.05rem",
                                        fontFamily: "'Inter', sans-serif"
                                    }}
                                />
                            ) : (
                                <p style={{ color: "#666", fontStyle: "italic" }}>No additional content available.</p>
                            )}
                        </div>

                        {/* Newsletter Table */}
                        {publication.newsletterEntries && publication.newsletterEntries.length > 0 && (
                          <div className="newsletter-section" style={{ 
                            marginTop: "10px",
                            backgroundColor: "#fff",
                            padding: "30px",
                            borderRadius: "12px",
                            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)"
                          }}>
                            <h2 style={{ 
                                marginBottom: "25px", 
                                color: "#009688",
                                fontSize: "1.5rem",
                                borderLeft: "4px solid #009688",
                                paddingLeft: "15px"
                            }}>Newsletter Table</h2>
                            <div style={{ overflowX: "auto", borderRadius: "8px", border: "1px solid #eee" }}>
                                <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "600px" }}>
                                  <thead>
                                    <tr style={{ background: "#009688", color: "white" }}>
                                      <th style={{ padding: "15px", textAlign: "left", fontWeight: "600" }}>Date</th>
                                      <th style={{ padding: "15px", textAlign: "left", fontWeight: "600" }}>Summary</th>
                                      <th style={{ padding: "15px", textAlign: "center", fontWeight: "600" }}>Attachment</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {publication.newsletterEntries.map((row, idx) => (
                                      <tr key={idx} style={{ 
                                          borderBottom: "1px solid #eee",
                                          transition: "background 0.2s"
                                      }}
                                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f9f9f9"}
                                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
                                      >
                                        <td style={{ padding: "15px", color: "#555", fontWeight: "500" }}>
                                            {row.month ? new Date(row.month).toLocaleDateString("en-US", { month: 'short', day: 'numeric', year: 'numeric' }) : "-"}
                                        </td>
                                        <td style={{ padding: "15px", color: "#666", lineHeight: "1.5" }}>{row.summary}</td>
                                        <td style={{ padding: "15px", textAlign: "center" }}>
                                            {row.attachment ? (
                                                <a 
                                                    href={row.attachment} 
                                                    target="_blank" 
                                                    rel="noreferrer"
                                                    style={{
                                                        display: "inline-block",
                                                        padding: "6px 15px",
                                                        backgroundColor: "#e0f2f1",
                                                        color: "#00796b",
                                                        textDecoration: "none",
                                                        borderRadius: "20px",
                                                        fontSize: "0.85rem",
                                                        fontWeight: "600",
                                                        transition: "all 0.3s"
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.backgroundColor = "#009688";
                                                        e.target.style.color = "#fff";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.backgroundColor = "#e0f2f1";
                                                        e.target.style.color = "#00796b";
                                                    }}
                                                >
                                                    View Document
                                                </a>
                                            ) : "-"}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                            </div>
                          </div>
                        )}
                    </div>

                    {/* Sidebar: More Publications */}
                    {allPublications && allPublications.length > 1 && (
                      <div className="pop-sidebar" style={{ marginTop: "0" }}>
                        <h3>More Publications</h3>
                        <div className="popular-publications">
                          {allPublications
                            .filter((pub) => pub.title !== publication.title)
                            .slice(0, 5) // Limit to 5 in sidebar
                            .map((pub, index) => (
                              <div
                                key={index}
                                className="popular-pub-item"
                                onClick={() => {
                                    navigate("/publication-detail", {
                                        state: { publication: pub, allPublications },
                                    });
                                    window.scrollTo(0, 0);
                                }}
                              >
                                {pub.imgSrc && <img src={pub.imgSrc} alt={pub.title} />}
                                <h4>{pub.title}</h4>
                              </div>
                            ))}
                        </div>
                      </div>
                    )}
                </div>

                {/* Back Button */}
                <div style={{ textAlign: "center", padding: "20px" }}>
                    <button
                        onClick={() => navigate("/publications")}
                        style={{
                            padding: "10px 30px",
                            backgroundColor: "#007bff",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: "1rem",
                        }}
                    >
                        Back to Publications
                    </button>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default PublicationDetailPage;
